var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.067 4.341l.291.03a2.99 2.99 0 012.64 2.584c.236 1.799.354 3.564.354 5.295 0 1.49-.087 2.98-.262 4.468l-.095.743a2.988 2.988 0 01-2.533 2.553c-2.103.305-5.152.457-9.147.457-3.704 0-6.576-.103-8.617-.311l-.286-.03a2.99 2.99 0 01-2.636-2.597 42.138 42.138 0 01-.341-5.283c0-1.479.083-2.985.25-4.52l.09-.77A2.992 2.992 0 013.42 4.362c1.96-.212 4.75-.322 8.372-.332h.523c3.753 0 6.67.104 8.752.312zm-10.964 4.29v7.203l5.915-3.601-5.915-3.603z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

export default SvgYoutube;